<template>
    <ContentOrLoading style="min-height: 600px">
        <LayoutSports v-if="event" :event="event" :event_id="event_id" :sesion_id="sesion_id"/>
    </ContentOrLoading>
</template>

<script>
    import LayoutSports from './layouts/show/Sports';

    export default {
        props: ['event_id', 'sesion_id'],
        data() {
            return {
                event: null
            }
        },
        components: {
            LayoutSports,
        },
        created() {
            this.getEvent();
        },
        computed : {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            checkVentaCerrada() {
                if (
                    (this.event.venta_online_cerrada || this.event.venta_online_cerrada_definitiva || this.event.status != 1) &&
                    (
                        document.location.href.indexOf('venta_online=test') === -1 &&
                        document.location.href.indexOf('venta_online=preventa-53578') === -1
                    ) &&
                    (
                        this.configuracion.hash_teatro !== "PTNL6tp97mBUGDchX6d4" ||
                        document.location.href.indexOf('venta_online=preventa-53578') === -1
                    )
                ) {
                    return false;
                } else {
                    return true
                }
            }
        },
        methods: {
            getEvent() {
                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro
                    },
                    event_id: this.event_id,
                    sesion_id: this.sesion_id
                }
        
                this.$store.dispatch(this.config.getVuexAlias('front.events.show'), params).then(res => {
                    this.event = res.data.data;
                    if(!this.checkVentaCerrada) {
                        this.$router.push({ name: 'front.eventos.index' });
                    }
                }).catch(error => {
                    this.$router.push({ name: 'front.eventos.index' });
                });
            },
        }
    }
</script>
